module.exports = __webpack_public_path__ + "media/images/icons/flags/LC-cb1075fedde7452143fa73bfa2f435a1.svg";